import { render } from "./UserRequestRegisterList.vue?vue&type=template&id=168e2d80&scoped=true"
import script from "./UserRequestRegisterList.vue?vue&type=script&lang=js"
export * from "./UserRequestRegisterList.vue?vue&type=script&lang=js"

import "./UserRequestRegisterList.vue?vue&type=style&index=0&id=168e2d80&scoped=true&lang=css"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168e2d80"]])

export default __exports__